/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SmartRecommenderAPI
 * @hideconstructor
 *
 * @classdesc
 */
define([], () => {
	class DeprecatedSmartsRecommenderAPI {

		/**
		 * @function DeprecatedSmartsRecommenderAPI#recommendAlternateVisualizationsAsWidgetSpecs
		 * @param {String} dataSource
		 * @param {String[]} columnIds
		 * 
		 * @deprecated
		 *
		 */
		recommendAlternateVisualizationsAsWidgetSpecs() {}

		/**
		 * @function DeprecatedSmartsRecommenderAPI#recommendRelatedVisualizationsAsWidgetSpecs
		 * @param {String} dataSource
		 * @param {String[]} columnIds
		 * @param {Boolean} includeBestVisForTargetFields
		 * 
		 * @deprecated
		 *
		 */
		recommendRelatedVisualizationsAsWidgetSpecs() {}


		/**
		 * @function DeprecatedSmartsRecommenderAPI#transformRecommendationsToLiveWidgetSpec
		 * @param {Object[]} recommendations
		 * @param {Object} options
		 * @deprecated
		 *
		 */
		transformRecommendationsToLiveWidgetSpecs() {}
	}

	return DeprecatedSmartsRecommenderAPI;
});
